/**
 * Which company fields appear in the company header, as stored per tenant by
 * `GET/PUT /CompanyHeaderDisplaySettings`. Read by the settings UI and by the
 * header-rendering work in WWM-18242.
 */
export interface ICompanyHeaderDisplaySettingsDTO {
  showCompanyName: boolean
  showAddress: boolean
  showCity: boolean
  showState: boolean
  showPostalCode: boolean
}

/** What the server returns for a tenant that has never saved the setting. */
export const DEFAULT_COMPANY_HEADER_DISPLAY_SETTINGS: ICompanyHeaderDisplaySettingsDTO =
  {
    showCompanyName: false,
    showAddress: false,
    showCity: false,
    showState: false,
    showPostalCode: false,
  }

/** `loading` tracks the GET, `saving` tracks the PUT. */
export interface State {
  settings: ICompanyHeaderDisplaySettingsDTO
  loading: boolean
  saving: boolean
}
